import { PreparedConversationParticipantOption } from 'src/graphql';
import { create } from 'zustand';

interface SelectedConversationRequesterState {
  selectedConversationRequester: PreparedConversationParticipantOption | null;
  setPartnerSelectedConversationRequester: (
    value: PreparedConversationParticipantOption | null,
  ) => void;
}

export const useSelectedConversationRequesterStore =
  create<SelectedConversationRequesterState>((set) => ({
    selectedConversationRequester: null,
    setPartnerSelectedConversationRequester: (data) =>
      set(() => ({ selectedConversationRequester: data })),
  }));
